export function KameArukuIcon({ className = "" }: { className?: string }) {
  return (
    <svg
      width="126"
      height="81"
      viewBox="0 0 126 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_kame)">
        <path
          d="M29.5621 77.9103C35.0095 77.9103 39.4255 73.4944 39.4255 68.047C39.4255 62.5996 35.0095 58.1836 29.5621 58.1836C24.1147 58.1836 19.6987 62.5996 19.6987 68.047C19.6987 73.4944 24.1147 77.9103 29.5621 77.9103Z"
          fill="#F4E6DC"
          stroke="black"
          strokeWidth="2.85069"
          strokeMiterlimit="10"
        />
        <path
          d="M120.498 54.2216C120.498 45.9831 113.827 39.3125 105.589 39.3125H19.4411C11.2026 39.3125 4.53198 45.9831 4.53198 54.2216C4.53198 62.4601 11.2026 69.1307 19.4411 69.1307H33.8085C33.9511 74.3759 38.2271 78.5949 43.5294 78.5949C48.8316 78.5949 53.0792 74.3759 53.2502 69.1307H99.7734C99.9159 74.3759 104.192 78.5949 109.494 78.5949C114.797 78.5949 119.215 74.2334 119.215 68.8741C119.215 66.7646 118.531 64.8546 117.419 63.2583C119.358 60.7497 120.526 57.6424 120.526 54.2216H120.498Z"
          fill="#F4E6DC"
          stroke="black"
          strokeWidth="2.85069"
          strokeMiterlimit="10"
        />
        <path
          d="M29.9895 40.6785C28.5356 30.302 39.9099 14.5092 46.837 9.63457C68.7588 -5.78764 105.761 1.36758 119.587 24.3441C124.119 31.8984 127.027 50.2854 121.639 59.208C115.567 69.2424 98.2349 65.7361 73.9185 60.8329C49.6877 55.9297 31.6144 52.2808 29.9895 40.6785Z"
          fill="#05B45B"
          stroke="black"
          strokeWidth="2.85069"
          strokeMiterlimit="10"
        />
        <path
          d="M24.5158 36.5748C24.5158 33.3945 21.9377 30.8164 18.7574 30.8164C15.5771 30.8164 12.999 33.3945 12.999 36.5748V42.6468C12.999 45.827 15.5771 48.4051 18.7574 48.4051C21.9377 48.4051 24.5158 45.827 24.5158 42.6468V36.5748Z"
          fill="white"
          stroke="black"
          strokeWidth="2.85069"
          strokeMiterlimit="10"
        />
        <path
          d="M17.4172 38.7681C19.4167 38.7681 21.0376 37.1472 21.0376 35.1477C21.0376 33.1482 19.4167 31.5273 17.4172 31.5273C15.4178 31.5273 13.7969 33.1482 13.7969 35.1477C13.7969 37.1472 15.4178 38.7681 17.4172 38.7681Z"
          fill="black"
        />
        <path
          d="M12.9418 36.5748C12.9418 33.3945 10.3637 30.8164 7.18343 30.8164C4.00317 30.8164 1.42505 33.3945 1.42505 36.5748V42.6468C1.42505 45.827 4.00317 48.4051 7.18343 48.4051C10.3637 48.4051 12.9418 45.827 12.9418 42.6468V36.5748Z"
          fill="white"
          stroke="black"
          strokeWidth="2.85069"
          strokeMiterlimit="10"
        />
        <path
          d="M5.81519 38.7681C7.81467 38.7681 9.43557 37.1472 9.43557 35.1477C9.43557 33.1482 7.81467 31.5273 5.81519 31.5273C3.81572 31.5273 2.19482 33.1482 2.19482 35.1477C2.19482 37.1472 3.81572 38.7681 5.81519 38.7681Z"
          fill="black"
        />
        <path
          d="M44.6138 38.4572C44.6138 38.4572 43.9011 32.7274 42.7038 29.1355C41.5921 25.7432 38.4563 21.2676 38.4563 21.2676C38.4563 21.2676 42.5613 19.3576 45.7541 16.8775C48.6618 14.597 52.7667 9.92188 52.7667 9.92188C52.7667 9.92188 53.5364 15.5947 55.0473 19.5857C56.3016 22.978 58.9242 27.14 58.9242 27.14C58.9242 27.14 54.2776 29.2495 51.598 31.188C48.9183 33.1265 44.6138 38.4857 44.6138 38.4857V38.4572Z"
          fill="white"
          stroke="black"
          strokeWidth="2.85069"
          strokeMiterlimit="10"
        />
        <path
          d="M62.4867 35.8327C62.4867 35.8327 62.1446 32.9535 61.546 31.1576C60.9758 29.4472 59.408 27.2236 59.408 27.2236C59.408 27.2236 61.4605 26.2829 63.0568 25.0286C64.5107 23.8883 66.5632 21.5508 66.5632 21.5508C66.5632 21.5508 66.9623 24.4015 67.7035 26.3969C68.3306 28.1074 69.6419 30.1599 69.6419 30.1599C69.6419 30.1599 67.3329 31.2146 65.9645 32.1838C64.5962 33.1531 62.4582 35.8327 62.4582 35.8327H62.4867Z"
          fill="white"
          stroke="black"
          strokeWidth="2.85069"
          strokeMiterlimit="10"
        />
        <path
          d="M94.5568 44.614C94.5568 44.614 94.2147 41.7348 93.616 39.9388C93.0459 38.2284 91.478 36.0049 91.478 36.0049C91.478 36.0049 93.5305 35.0642 95.1269 33.8099C96.5808 32.6696 98.6332 30.332 98.6332 30.332C98.6332 30.332 99.0323 33.1827 99.7735 35.1782C100.401 36.8886 101.712 38.9411 101.712 38.9411C101.712 38.9411 99.4029 39.9959 98.0346 40.9651C96.6663 41.9343 94.5283 44.614 94.5283 44.614H94.5568Z"
          fill="#E1FF60"
          stroke="black"
          strokeWidth="2.85069"
          strokeMiterlimit="10"
        />
        <path
          d="M76.5698 47.2658C76.5698 47.2658 75.8572 41.536 74.6599 37.9441C73.5481 34.5518 70.4124 30.0762 70.4124 30.0762C70.4124 30.0762 74.5173 28.1662 77.7101 25.6861C80.6178 23.4056 84.7228 18.7305 84.7228 18.7305C84.7228 18.7305 85.4925 24.4033 87.0033 28.3943C88.2576 31.7866 90.8803 35.9486 90.8803 35.9486C90.8803 35.9486 86.2337 38.0581 83.554 39.9966C80.8744 41.935 76.5698 47.2943 76.5698 47.2943V47.2658Z"
          fill="white"
          stroke="black"
          strokeWidth="2.85069"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_kame">
          <rect width="126" height="80.0473" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
